import React from 'react';

import Icon from '~/core/scripts/components/Icon';
import { numberFormat } from '~/core/scripts/utils';
import { getIconType } from '~/kits/general/scripts/utils';
import Arrow from '../Arrow';
import config from '../config';

export default props => {
  const firstYearData = props.segmentData.find(d => d.Jahr === '2010');
  const lastYearData = props.segmentData.find(d => d.Jahr === '2019');

  return (
    <div className="segmentinfo">
      <div className="segmentinfo__header" style={{ backgroundColor: props.colorBright}}>
        <div className="segmentinfo__title">
          <Icon type={getIconType(props.segmentName)} color={props.colorDark} />
          <div style={{ color: props.colorDark }}>{config[props.segmentName].label}</div>
        </div>
        <div className="segmentinfo__subheader">
          <div className="segmentinfo__subheader-model">
            <strong>Top Modelle</strong> (2019): {lastYearData.Modell_Top1}, {lastYearData.Modell_Top2},{' '}
            {lastYearData.Modell_Top3}
          </div>
          <div className="segmentinfo__subheader-rank">
            <strong>CO2-Ausstoß</strong> (WLTP): <div className="circle" style={{ backgroundColor: props.color }}></div>{' '}
            {lastYearData.CO2_Segment} g
          </div>
        </div>
      </div>
      <div className="segmentinfo__content">
        <div className="segmentinfo__share">
          <div className="segmentinfo__content-title">Zulassungen</div>
          <div className="segmentinfo__content-items">
            <div className="segmentinfo__content-item">
              <div className="segmentinfo__content-itemtitle">2010</div>
              <div className="segmentinfo__content-itemvalue">{numberFormat(firstYearData.value)}</div>
              <div className="segmentinfo__content-rel">{numberFormat(props.dataRel[0], 1)} %</div>
            </div>
            <Arrow style={{ maxWidth: 200 }} />
            <div className="segmentinfo__content-item">
              <div className="segmentinfo__content-itemtitle">2019</div>
              <div className="segmentinfo__content-itemvalue">
                <strong>{numberFormat(lastYearData.value)}</strong>
              </div>
              <div className="segmentinfo__content-rel">{numberFormat(props.dataRel[1], 1)} %</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
